import styles from "./insurance.module.scss";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/img/logo.svg";

function Insurance() {
	const navigate = useNavigate();
	return (
		<div className={styles.container}>
			<div className="flex justify-between my-10">
				<img src={logo} className="w-32" />

				<button
					onClick={() => {
						navigate("/");
					}}
					className="bg-sky-600 p-2 rounded-lg text-white"
				>
					بازگشت
				</button>
			</div>
			<h1 className="text-2xl  font-black	mb-10">
				چگونه داروی تیالیا را با بیمه تهیه کنیم؟
			</h1>
			<p className="text-white text-justify">
				<p className="mb-10">
					داروی تیالیا تحت پوشش تمامی بیمه های پایه از جمله تامین اجتماعی، خدمات
					درمانی(سلامت) و نیروهای مسلح می باشد. شایان ذکر است جهت بهره مندی از
					خدمات بیمه ای، از ثبت نسخه الکترونیکی توسط پزشک معالج خود و همچنین به
					همراه داشتن اسکن عکس چشم(OCT) و کارت ملی بیمار هنگام مراجعه به مراکز
					بیمه یا داروخانه ها اطمینان حاصل بفرمایید.{" "}
				</p>
				<br />
				<strong className="font-black">شهر تهران:</strong>
				<br />
				{/* <p className="mt-5">
					مراجعه به‌ داروخانه‌های ۱۳ آبان، ۲۹ فروردین، هلال‌احمر یا شهید کاظمی
					در ساعت اداری (۸ تا ۱۳) جهت تشکیل پرونده و تهیه دارو. مراجعه به اسناد
					پزشکی بیمه تامین‌اجتماعی (خیابان کارگر، روبروی پارک لاله) و یا مرکز
					اسناد پزشکی بیمه خدمات‌درمانی (خیابان فاطمی، رو‌به‌روی سازمان آب، پلاک
					16)، جهت تشکیل پرونده، سپس تهیه دارو از داروخانه‌های خصوصی یا دولتی.
				</p>
				p */}
				<ul className="mr-10">
					<li className="list-disc">
						<p className="mt-5 	">
							مراجعه به‌ داروخانه‌های ۱۳ آبان، ۲۹ فروردین، هلال‌احمر یا شهید
							کاظمی در ساعت اداری (۸ تا ۱۳) جهت تشکیل پرونده و تهیه دارو.
						</p>
					</li>
					<li className="list-disc">
						<p className="mt-5">
							مراجعه به اسناد پزشکی بیمه تامین‌اجتماعی (خیابان کارگر، روبروی
							پارک لاله) و یا مرکز اسناد پزشکی بیمه خدمات‌درمانی (خیابان فاطمی،
							رو‌به‌روی سازمان آب، پلاک 16)، جهت تشکیل پرونده، سپس تهیه دارو از
							داروخانه‌های خصوصی یا دولتی.
						</p>
					</li>
				</ul>

				<br />
				<strong>شهرستان‌ها:</strong>
				<br />

				<ul className="mr-10">
					<li className="list-disc">
						<p className="mt-5 	">
							مراجعه به‌ داروخانه‌های دولتی و مرجع در ساعت اداری (۸ تا ۱۳) جهت
							تشکیل پرونده و تهیه دارو.{" "}
						</p>
					</li>
					<li className="list-disc">
						<p className="mt-5">
							مراجعه به مراکز اسناد پزشکی بیمه مربوطه، جهت تشکیل پرونده و سپس
							تهیه دارو از داروخانه‌های خصوصی یا دولتی.{" "}
						</p>
					</li>
				</ul>
				<br />
				<strong>بیمه‌ بانک‌ها:</strong>
				<br />

				<ul className="mr-10">
					<li className="list-disc">
						<p className="mt-5 	">
							تهیه دارو به‌صورت آزاد از داروخانه‌های خصوصی یا دولتی و سپس دریافت
							وجه از بیمه خود.{" "}
						</p>
					</li>
					<li className="list-disc">
						<p className="mt-5">
							مراجعه به داروخانه‌های طرف قرارداد با بیمه بانک‌ها.{" "}
						</p>
					</li>
				</ul>
			</p>
		</div>
	);
}

export default Insurance;
